<div class="brn-edit-attribute-edit">
  <span class="custom-input placeholder-small placeholder-active">
    {{ label }}
  </span>
  <angular-editor
    [id]="'editor-' + label"
    [config]="editorConfig"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    (ngModelChange)="onValueChange($event)"
  >
  </angular-editor>
</div>
